import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tooltip } from 'antd';
import { ExclamationCircleIcon } from '../../../custom_shared/icons';
import { SectionModel } from '../../models';
import './SectionHeader.less';

interface Props {
    section: SectionModel;
}

const SectionHeader: React.FC<Props> = ({ section }) => {
    return (
        <div className="sections-layout-header-container">
            <span className="header-title">{section.name}</span>

            {section.description && (
                <Tooltip title={section.description} placement="topLeft" overlayStyle={{ maxWidth: 800 }}>
                    <ExclamationCircleIcon width={20} height={20} color="black" />
                </Tooltip>
            )}
        </div>
    );
};

export default observer(SectionHeader);
